import React from 'react'
// useState commented out - Find a Part section (may be restored later)
import PropTypes from 'prop-types'
import tw, { styled } from 'twin.macro'
import { Link, graphql } from 'gatsby'

import Layout from '../../components/layout'
import Meta from '../../components/meta'
import filterLocale from '../../components/utils/filter-locale'
import SupportSearch from '../../components/support/support-search'
import Tabs from '../../components/support/tabs'
// Commented out - Find a Part section (may be restored later)
// import {
// 	ListboxInput,
// 	ListboxButton,
// 	ListboxList,
// 	ListboxOption,
// 	ListboxPopover,
// } from '@reach/listbox'
// import '@reach/listbox/styles.css'
// import spares from '../../spares/spares-2020.json'

const ContentsSection = tw.section`w-full bg-gray-200`
const ContentsContainer = styled.div`
	${tw`w-95 md:w-11/12 bg-white py-10 px-4 md:px-8 mx-auto border-l border-r border-gray-300 border-b rounded-b-lg mb-16`}
`
// Commented out - Find a Part section styles (may be restored later)
// ContentsContainer styles that were removed:
// [data-reach-listbox-button] {
// 	${tw`py-2 px-2 font-display text-sm font-semibold rounded`}
// }
// #my-label {
// 	${tw`font-display py-2 mr-0 md:mr-2`}
// }
// Commented out - Find a Part section styled components (may be restored later)
// const Popover = styled(ListboxPopover)`
// 	${tw`font-display text-sm`}
// 	z-index: 100;
// `
// const TableHolder = tw.div`overflow-auto mb-12`
// const Table = styled.table`
// 	${tw`w-full table-auto mt-4`}
// 	> tbody > tr > th {
// 		${tw`font-display border px-4 py-2 w-1/5`}
// 	}
// 	> tbody > tr > td {
// 		min-width: 200px;
// 		${tw`font-display border px-4 py-2 text-center`}
// 		> a {
// 			${tw`underline text-blue-500 hover:no-underline`}
// 		}
// 	}
// `
// const FieldsContainer = styled.div`
// 	${tw`flex flex-col md:flex-row items-start md:items-center`}
// 	> div {
// 		${tw`flex flex-col md:flex-row mx-0 md:mx-2`}
// 	}
// 	.searchBar {
// 		${tw`mt-4 md:mt-0 p-2 border-2 border-black rounded`}
// 	}
// `

const TextsImageContainer = tw.div`flex flex-col md:flex-row mb-10`
const Header = tw.h2`font-display text-3xl md:text-4xl font-bold mb-6`
const HeaderSubText = styled.p`
	${tw`font-display text-base md:text-lg`}

	span {
		${tw`underline text-blue-500`}
	}
`

const BuyParts = styled(Link)`
	${tw`bg-yellow-500 hover:bg-yellow-400 font-display font-bold uppercase py-3 px-6 rounded mt-8 w-48 text-center`}
`
const TextsContainer = tw.div`flex flex-col mr-0 md:mr-4`

const ImageContainer = styled.div`
	${tw`mr-auto md:mr-0 md:ml-auto mt-4 md:mt-0`}

	> img {
		${tw`w-6/12 md:w-10/12 mr-auto md:mr-0 md:ml-auto`}
	}
`
const RepairsAndParts = ({ data: { repairparts } }) => {
	const locale = 'en-ZA'
	const [{ node }] = filterLocale(repairparts.edges, locale)

	const { seoTitle, seoKeywords, seoDescription } = node

	// Commented out - Find a Part section state (may be restored later)
	// const [keyword, setKeyword] = useState('')
	// const [value, setValue] = useState('Part Description')
	// const [res, setRes] = useState(10)
	// const x =
	// 	keyword != '' && value != 'default'
	// 		? spares.filter(x => {
	// 				const word = x[value].includes(keyword)
	// 				return word
	// 		  })
	// 		: false

	return (
		<Layout>
			<Meta
				title={seoTitle}
				keywords={seoKeywords}
				description={seoDescription}
				lang={locale}
			/>
			<SupportSearch />
			<Tabs locale={locale} />
			<ContentsSection>
				<ContentsContainer>
					<TextsImageContainer>
						<TextsContainer>
							<Header>Find an authorised Maytronics repairer</Header>
						<HeaderSubText>
							Keep your Dolphin in top condition by using a trusted Maytronics
							Authorised Service Centre that uses genuine Maytronics-approved
							spare parts, to ensure the highest quality repairs for your
							Dolphin.
						</HeaderSubText>
							<BuyParts to="/en-ZA/support/contact/?subject=spare-parts">Buy Parts</BuyParts>
						</TextsContainer>

						<ImageContainer>
							<img
								src="//images.ctfassets.net/ftcnv5up9dxv/OGmUM25A1ZqSWRQWRiXXk/8773e386dc7bd3d5490e0be319c0c8fd/Maytronics-Authorised-Service-Centre.jpg"
								alt="Maytronics-Authorised-Service-Centre"
							/>
						</ImageContainer>
					</TextsImageContainer>

					{/* Commented out - Find a Part section (may be restored later) */}
					{/* <Header>Find a Part</Header>

					<FieldsContainer>
						<div>
							<p id="my-label">Choose One</p>
							<ListboxInput
								onChange={value => {
									setValue(value)
								}}
							>
								<ListboxButton arrow="▼" />
								<Popover>
									<ListboxList>
										<ListboxOption value="default">--Select--</ListboxOption>
										<ListboxOption value="Part Number">
											Part Number
										</ListboxOption>
										<ListboxOption value="Part Description">
											Part Description
										</ListboxOption>
										<ListboxOption value="Family Description">
											Family Description
										</ListboxOption>
										<ListboxOption value="Price exGST">
											Price exGST
										</ListboxOption>
										<ListboxOption value="Price incGST">
											Price incGST
										</ListboxOption>
									</ListboxList>
								</Popover>
							</ListboxInput>
						</div>

						<div>
							<p id="my-label">Number of Results</p>
							<ListboxInput
								onChange={res => {
									setRes(res)
								}}
							>
								<ListboxButton arrow="▼" />
								<Popover>
									<ListboxList>
										<ListboxOption value="10">10</ListboxOption>
										<ListboxOption value="20">20</ListboxOption>
									</ListboxList>
								</Popover>
							</ListboxInput>
						</div>

						<input
							className="searchBar"
							type="text"
							value={keyword}
							placeholder="Search"
							onChange={e => {
								setKeyword(e.target.value)
							}}
						/>
					</FieldsContainer>

					<TableHolder>
						<Table>
							<tbody>
								<tr>
									<th>Part Number</th>
									<th>Part Description</th>
									<th>Family Description</th>
									<th>Price exGST</th>
									<th>Price incGST</th>
								</tr>
								{keyword === '' ? (
									spares.slice(0, res).map(x => {
										return (
											<tr key={x['Part Number']}>
												<td>{x['Part Number']}</td>
												<td>{x['Part Description']}</td>
												<td>{x['Family Description']}</td>
												<td>{x['Price exGST']}</td>
												<td>{x['Price incGST']}</td>
											</tr>
										)
									})
								) : keyword != '' && value != 'default' ? (
									x.length != 0 ? (
										x.slice(0, res).map(x => {
											return (
												<tr key={x['Part Number']}>
													<td>{x['Part Number']}</td>
													<td>{x['Part Description']}</td>
													<td>{x['Family Description']}</td>
													<td>{x['Price exGST']}</td>
													<td>{x['Price incGST']}</td>
												</tr>
											)
										})
									) : (
										<tr>
											<td colSpan="5">
												No Result for this query, Please try again.
											</td>
										</tr>
									)
								) : (
									<tr>
										<td colSpan="5">Select is empty, Please Choose One.</td>
									</tr>
								)}
							</tbody>
						</Table>
					</TableHolder> */}
				</ContentsContainer>
			</ContentsSection>
		</Layout>
	)
}
/**
 * Page content query
 * @private
 * @static
 * @returns {() => void}
 */
export const staticQuery = graphql`
	query repairPartsZaQuery {
		repairparts: allContentfulPage(
			filter: { contentful_id: { eq: "2JhtBK7Tx60VtNIKeD6eoL" } }
		) {
			edges {
				node {
					seoTitle
					seoKeywords
					seoDescription
					node_locale
					slug
					body {
						json
					}
				}
			}
		}
	}
`
RepairsAndParts.propTypes = {
	data: PropTypes.shape({
		repairparts: PropTypes.objectOf(PropTypes.array),
	}),
}

export default RepairsAndParts
